import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { IconController } from "../../../../../Scripts/ImgController";
import assets from "../../../../../../assets/assets";
import ActionButtons from "../ActionButtons";
import { TERMS_SECTIONS } from "../../../../../static";
import { useContract } from "../../../../../../provider/ContractProvider";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  background: #00000099;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.6ms ease;

  .modal-animate {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .modal-show {
    opacity: 1;
    transform: translateY(0);
  }
  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    background: white;
    max-width: 950px;
    width: 100%;
    z-index: 100;
  }

  .paragraph-CK {
    color: #344054;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-basis: 30%;
  }
`;

const TermsConditional = () => {
  const { handleNext, handlePrevious } = useContract();
  const scrollRef = useRef(null);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setIsScrolledToEnd(true);
      }
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTONext = () => {
    if (isScrolledToEnd) handleNext();
  };
  return (
    <Wrapper>
      <div className="w-full h-full flex justify-center items-center relative z-102">
        <div className="border-CK relative overflow-hidden">
          <div className="w-full border-b border-[#E4E7EC] z-50">
            <div className="flex p-6">
              <div className="p-2 bg-mmusic rounded-xl">
                <IconController
                  src={assets.svg.fileEditWhite}
                  alt="Mmusic Logo"
                  className="h-9 w-9"
                />
              </div>
              <div className="ml-4 w-full">
                <h3 className="font-semibold text-lg leading-7 text-[#0B0C0F]">
                  Уран бүтээлчийн үйлчилгээний нөхцөл
                </h3>
                <h5 className="text-sm font-normal text-[#475467] pt-1">
                  Сүүлд өөрчлөлт орсон огноо: 16.05.2025
                </h5>
              </div>
            </div>
          </div>

          <div className="flex">
            <div ref={scrollRef} className="h-[600px] overflow-y-scroll w-full">
              <div className="p-6 pb-9">
                <div className="w-full space-y-4 text-sm">
                  {TERMS_SECTIONS.map((section, i) => (
                    <div key={i}>
                      <h1 className="font-bold italic">{section.title}</h1>
                      {section.content.map((item, idx) => (
                        <div key={idx} className="pt-1">
                          <h5 className="text-black text-xs font-semibold leading-4 py-2">
                            {item.subtitle}
                          </h5>
                          <p className="text-xs leading-5">{item.text}</p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="py-12.5"></div>
          <ActionButtons
            isFormValid={isScrolledToEnd}
            handlePrevious={handlePrevious}
            onSubmit={handleTONext}
            previousLabel="Буцах"
            submitLabel="Үргэлжлүүлэх"
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default TermsConditional;
